import { combineReducers } from 'redux';
import orderReducer from '../../modules/Order/store/reducer';
import cartReducer from '../../modules/Cart/store/reducer';
import authReducer from '../../modules/Auth/store/reducer';
import shippingAddressReducer from '../../modules/ShippingAddress/store/reducer';
import cartItemEditorReducer from '../../modules/CartItemEditor/store/reducer';
import productReducer from '../../modules/Products/store/reducer';
import photoReducer from '../../modules/Photo/store/reducer';
import photoEditorReducer from '../../modules/PhotoEditor/store/reducer';
import confirmReducer from '../../modules/Confirm/store/reducer';
import couponReducer from '../../modules/Coupon/store/reducer';
import appReducer from '../../modules/App/store/reducer';
var rootReducer = combineReducers({
    app: appReducer,
    auth: authReducer,
    cart: cartReducer,
    order: orderReducer,
    photo: photoReducer,
    coupon: couponReducer,
    confirm: confirmReducer,
    products: productReducer,
    photoEditor: photoEditorReducer,
    cartItemEditor: cartItemEditorReducer,
    shippingAddress: shippingAddressReducer,
});
export default rootReducer;
